<app-form-page [content]="content"/>

<ng-template #content>
  <div class="m-t-2 m-b-3 text-align-center">
    <svg-icon
      role="img"
      src="assets/images/aptem-assess-logo-content.svg"
      data-ua-id="landing-page-logo"
    >
    </svg-icon>
  </div>
  <div>
    <h2 class="text-bold m-b-3 text-align-center">
        <span>We are building your Admin Centre</span>
    </h2>
  </div>
  <div>
    <p>
      We’re setting up your free organisation. Once it’s ready, you’ll receive an email inviting you to set your password and log in to the Admin Centre. We will provide instructions to enable you to start sending out assessments.
    </p>
    <p>
      If it takes longer than expected please contact: <a href="mailto:support@aptemassess.co.uk">support&commat;aptemassess.co.uk</a>
    </p>
  </div>
  <div>
    <p>You can now close this browser window.</p>
  </div>
</ng-template>
